angular
  .module('contrast.services.time', [])
  .factory('TimeService', function (ProfileService, DEFAULT_DATETIME_FORMAT) {
    'ngInject'

    var service = {
      getDateFormat,
      getDateTimeFormat: getDateTimeFormat,
      getTimeInUserTimeZone: getTimeInUserTimeZone,
      getOffsetDifference: getOffsetDifference,
      getLastDay: getLastDay,
      getLastHour: getLastHour,
      getLastWeek: getLastWeek,
      getLastWeekLocalTimeZone: getLastWeekLocalTimeZone,
      getLastThirtyDays: getLastThirtyDays,
      getLastThreeMonths: getLastThreeMonths,
      getLastYear: getLastYear,
      getTimezoneOffsetString,
      format: format
    }

    return service

    function getTimeInUserTimeZone(epochTime) {
      var timezone = ProfileService.getTimezone()
      if (moment(epochTime, 'x').isValid()) {
        var helperDate = moment(epochTime, 'x').format('MM-DD-YYYY HH:mm')
        var timezoneMoment = moment.tz(helperDate, 'MM-DD-YYYY HH:mm', timezone)
        return timezoneMoment.format('x')
      }
      return undefined
    }

    function getTimezoneOffsetString() {
      return moment.tz(ProfileService.getTimezone()).format('Z')
    }

    // used to get the "user settings" time zone UTC offset
    // by comparing vs the local time
    function getOffsetDifference() {
      var timezone = ProfileService.getTimezone()

      var momentInUserTimezone = moment().tz(timezone)
      var momentInBrowserTimezone = moment()

      return (
        momentInUserTimezone.utcOffset() - momentInBrowserTimezone.utcOffset()
      )
    }

    // Convert java date format string to moment.js format string
    function getDateFormat() {
      var jformat = ProfileService.getDateFormat() || DEFAULT_DATE_FORMAT
      return moment().toMomentFormatString(jformat)
    }

    // Convert java date format string to moment.js format string
    function getDateTimeFormat() {
      var jformat =
        ProfileService.getDateTimeFormat() || DEFAULT_DATETIME_FORMAT
      return moment().toMomentFormatString(jformat)
    }

    function getLastDay() {
      return {
        startDate: moment()
          .subtract(1, 'days')
          .add(getOffsetDifference(), 'm') // parse to the "user settings" time zone
          .format(getDateTimeFormat()),
        endDate: moment()
          .add(getOffsetDifference(), 'm') // parse to the "user settings" time zone
          .format(getDateTimeFormat())
      }
    }

    function getLastHour() {
      return {
        startDate: moment()
          .subtract(1, 'hours')
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat()),
        endDate: moment()
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat())
      }
    }

    function getLastWeek() {
      return {
        startDate: moment()
          .subtract(1, 'weeks')
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat()),
        endDate: moment()
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat())
      }
    }

    // created this method to avoid changing the prev behavior of
    // cs-date-range-picker.controller.js#cs-date-range-picker.controller.js-52
    // where for this usage, we are not setting the date using the "user settings" time zone
    // we are trusting on the local time zone
    // for more context:
    // https://contrast.atlassian.net/wiki/spaces/PROTECTENG/pages/2438136039/TS-4706+Attack+Attack+Events+Grid+Date+Picker+end+time+is+an+hour+off
    function getLastWeekLocalTimeZone() {
      return {
        startDate: moment().subtract(1, 'weeks').format(getDateTimeFormat()),
        endDate: moment().format(getDateTimeFormat())
      }
    }

    function getLastThirtyDays() {
      return {
        startDate: moment()
          .subtract(30, 'days')
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat()),
        endDate: moment()
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat())
      }
    }

    function getLastThreeMonths() {
      return {
        startDate: moment()
          .subtract(3, 'months')
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat()),
        endDate: moment()
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat())
      }
    }

    function getLastYear() {
      return {
        startDate: moment()
          .subtract(1, 'year')
          .startOf('year')
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat()),
        endDate: moment()
          .add(getOffsetDifference(), 'm')
          .format(getDateTimeFormat())
      }
    }

    function format(str) {
      return moment(str).format(getDateTimeFormat())
    }
  })
